/**
 * 模块接口
 */
import { get, post } from '@/http/request'
import qs from 'qs'

/**
 * 工作台
 */
export const reqTodayCount = (params) => get(`vip/data/today/count`, params)
export const reqTotalCount = (params) => get(`vip/data/total/count`, params)

/**
 * 用户管理
 */
// 新增用户
export const addNewUser = (params) => post(`/vip/user/save`, params)
// 用户详情
export const UserDetail = (params) => get(`/vip/user/detail`, params)

// 修改用户 /  切换用户状态
export const UserUpdate = (params) => post(`/vip/user/update`, params)
// 删除用户
export const UserDelete = (params) => post(`/vip/user/delete`, qs.stringify(params))

// 用户列表
export const reqUserList = (params) => get(`/vip/user/page`, params)

// 地址列表
export const reqAddressList = (params) => get(`/vip/address/page`, params)
// 校验省市区是否开通
export const checkArea = (params) => post(`/vip/area/check`, qs.stringify(params), { 'content-type': 'application/x-www-form-urlencoded' })
// 新增地址
export const addAddress = (params) => post(`/vip/address/add`, params)
// 修改地址
export const updateAddress = (params) => post(`/vip/address/update`, params)
// 删除地址
export const delAddress = (params) => post(`/vip/address/delete`, params)
// 获取默认地址
export const getDefaultAddress = (params) => get(`/vip/address/getDefaultAddress`, params)
// 获取地址模板
export const downloadAddressTemplate = () => post(`/vip/address/downloadTemplate`, '', { responseType: 'blob' })

// 新下载模板 20201209新增
export const downloadTemplateNew = (params) => post(`/vip/excel/downloadTemplate`, params, { responseType: 'blob' })

// 物流信息-快件跟踪（单个）
export const getDetailByWaybillNo = (params) => get(`/vip/logisticsTracking/getDetailByWaybillNo`, params)

//  物流信息-快件跟踪（批量查询）
// export const getDetailByWaybillNos = (params) => get(`/vip/logisticsTracking/getDetailByWaybillNos`, params)
export const getDetailByWaybillNos = (reqData) => post(`/vip/logisticsTracking//v2/getDetailByWaybillNo`, reqData)

//  运费计算
// export const freightCalculation = (params) => post(`/vip/costCalculation/spmCustomerShippingQuote/comCost`, params)

//  通过省市区匹配结算目的地
export const getSettlement = (params) => post(`/vip/area/getSettlementDestinationByProvinceCityAreaId`, params)

// 单票下单：新增订单
export const vipOrderAdd = (reqData) => post(`/vip/order/add`, reqData)

// 单票下单：运费计算
export const getComCost = (reqData) => post(`/vip/costCalculation/spmCustomerShippingQuote/comCost`, reqData)

// 单票下单：赔偿上限服务费计算
export const getComputationCost = (reqData) => post(`/vip/costCalculation/insuranceFee/computationCost`, reqData)

// 单票下单：代收货款手续费计算
export const getCalc = (reqData) => post(`/vip/costCalculation/spmiCollectionfeeCustomerFee/calc`, reqData)

// 赔偿上限服务费计算（批量）
export const getcomCostBatch = (reqData) => post(`/vip/costCalculation/insuranceFee/comCostBatch`, reqData)

// 单票下单：综合拉取基础数据
export const getList = () => get(`/vip/baseData/list`)

// 单票下单：列表带分页
export const addressPage = (params) => get(`/vip/address/page`, params)

// 单票下单：是否代收货款
export const customerCod = (params) => get(`/vip/network/customerCod`, params)

// 单票下单：新增地址
export const addressAdd = (reqData) => post(`/vip/address/add`, reqData)

// 运单：运单列表
export const waybillOrder = (params) => post(`/vip/waybillOrder/page`, params)

// 运单：运单状态数据统计
export const countByStatus = (params) => post(`/vip/waybillOrder/countByStatus`, params)

// 运单：运单导出
export const waybillExport = (reqData) => post(`/vip/waybillOrder/export`, reqData, { responseType: 'arraybuffer' })
// 运单：异步运单导出
export const asyExportWaybill = (reqData) => post(`/vip/waybillOrder/asyExport`, reqData)

// 运单：运单删除
export const waybillDelete = (reqData) => post(`/vip/waybillOrder/delete`, qs.stringify(reqData))

// 运单：运单详情
export const getDetailById = (params) => get(`/vip/waybillOrder/getDetailByNo`, params)

// 运单：根据运单号查询退件登记时间
export const getRebackExpress = (params) => get(`/vip/waybillOrder/getRebackExpress`, params)

// 订单：订单列表
export const orderList = (reqData) => post(`/vip/order/list`, reqData)

// 订单：订单列表-三方下单
export const orderListThridNo = (reqData) => post(`/vip/thridOrder/noOrderlist`, reqData)

// 订单：订单列表-三方下单-立即下单
export const batchSave = (reqData) => post(`/vip/thridOrder/batchSave`, reqData)

// 订单：订单列表-三方下单-取消订单
export const cancelById = (reqData) => post(`/vip/shopify/order/cancle`, reqData)
// export const cancelById = (reqData) => get(`/vip/thridOrder/cancelByIds`, reqData)

// 订单：订单列表-三方订单
export const orderListThrid = (reqData) => post(`/vip/thridOrder/getPages`, reqData)

// 订单：订单状态分组统计总数
export const orderTotalGroup = (reqData) => post(`/vip/order/totalGroup`, reqData)

// 订单：三方订单分组统计总数
export const orderTotalGroupThrid = (reqData) => post(`/vip/thridOrder/totalGroup`, reqData)

// 订单：三方下单分组统计总数
export const orderTotalGroupThridNo = (reqData) => post(`/vip/thridOrder/noOrderTotalGroup`, reqData)

// 订单：修改订单
export const orderUpdate = (reqData) => post(`/vip/order/update`, reqData)

// 订单：合并订单
export const orderMerge = (reqData) => post(`/vip/order/merger`, reqData)

// 订单：订单详情
export const detailOrder = (params) => get(`/vip/order/detailOrder`, params)

export const noOrderDetail = (params) => get(`/vip/thridOrder/noOrderDetail`, params)

// 订单：订单导出
export const regularOutputExcel = (reqData) => post(`/vip/order/regularOutputExcel`, reqData, { responseType: 'arraybuffer' })

// 订单：订单异步导出
export const asyExportOrder = (reqData) => post(`/vip/order/asyExportOrder`, reqData)

// 订单：订单异步导出
export const asyExportOrderThrid = (reqData) => post(`/vip/thridOrder/asyExportOrder`, reqData)

// 订单：删除订单
export const orderrDelete = (reqData) => post(`/vip/order/delete?orderId=${reqData.orderId}`)

// 订单：订单子单打印
// export const printOrders = (params) => get(`/vip/order/printOrders`, params)
// export const printOrders = (reqData) => post(`/vip/order/newPrintOrders`, reqData, { responseType: 'blob' })
export const printOrders = (reqData) => post(`/vip/order/orderPrintUrl`, reqData)

export const printShopify = (reqData) => post(`/vip/shopify/orderPrintUrl`, reqData)

// 订单取消
export const orderCancel = (params) => post(`/vip/order/cancel`, params)

// 子订单查询
export const subOrderList = (params) => get(`/vip/order/subOrderList`, params)

// 子订单打印
export const printOrderSubs = (params) => get(`/vip/order/printOrderSubs`, params)

// 批量删除订单
export const orderBatchDelete = reqData => post(`/vip/order/batchDelete`, reqData)

/**
 * 批量下单
 */
// 订单列表

// 下载模板
export const downloadTemplate = (typeTemplate) => post(`/vip/order/${typeTemplate}`, '', { responseType: 'blob' })
// 批量导入
export const excelImport = (params) => post(`/vip/order/excelImport`, params)
// 批量新增订单
export const batchAdd = (params) => post(`/vip/order/batchAdd`, params)
// 批量取消订单
export const cancel = (params) => post(`/vip/order/cancel`, params)
// 客户订单号验重
export const checkRepeatCustomerOrderId = (params) => post(`/vip/order/checkRepeatCustomerOrderId`, params)

// 订单来源
export const queryCustomerOrderSource = (params) => get(`/vip/orderSource/order`, params)
// 同步shopify信息
export const shopifyOrderSync = (params) => get(`/vip/shopify/order/sync`, params)
// shopify 仓库地址
export const shopifyAddressList = (params) => get(`/vip/shopify/address/list`, params)
// shopify 批量修改地址
export const shopifyOrderAddrUpdate = (params) => post(`/vip/shopify/order/orderAddrUpdate`, params)
// shopify store list
export const shopifyMyStore = (params) => get(`/vip/shopify/myStore`, params)
// 匹配客户手动输入的地址
export const queryAddressAnalysisAddress = (params) => get(`/vip/address/analysisAddress`, params)

// 获取回单金额
export const getReceiptFee = (params) => get(`/vip/order/getReceiptFeeByCode`, params)

// 下载中心列表
export const downloadCenterList = (params) => post(`/vip/exportRecord/page`, params)
// 下载中心列表删除
export const downloadCenterReqDel = (reqData) => post(`/vip/exportRecord/delete`, reqData)

// 获取币别
export const getsysCurrencyType = (params) => get(`/vip/sysCurrencyType/list`, params)

// 更新下载状态
export const updateFinishDownLoad = (params) => post(`/vip/exportRecord/updateFinishDownLoad`, params)

export const getImgList = params => post('/vip/logisticsTracking/getSignPictureUrls', params)

export const problemList = params => post('/vip/problem/list', params)

export const problemDesc = params => post('/vip/problem/desc', params)

export const asyExportList = params => post('/vip/problem/asyExportList', params)

export const asyExportDesc = params => post('/vip/problem/asyExportDesc', params)

// 修改手机号
export const updateReceiverMobilePhone = params => post('/vip/waybillOrder/updateReceiverMobilePhone', params)

// 获取订单量地区前十
export const getOrderCountTopTen = (params) => post(`/vip/inHarbor/cityTop`, params)

// 进港明细
export const enterPortDel = (params) => post(`/vip/inHarbor/detail`, params)

// 进港列表
export const reqReceiveList = (params) => post(`/vip/inHarbor/list`, params)

// 签收率走势图
export const trendChart = (params) => post(`/vip/inHarbor/trendChart`, params)

// 进港图表模式
export const getChart = (params) => post(`/vip/inHarbor/chart`, params)

// 进港导出
export const asyExport = (params) => post(`/vip/inHarbor/asyExport`, params)

// 进港明细导出
export const enterDetailExport = (params) => post(`/vip/inHarbor/asyDetailExport`, params)

// 出港导出
export const outAsyExport = (params) => post(`/vip/outHarbor/asyExport`, params)

// 出港明细导出
export const outDetailExport = (params) => post(`/vip/outHarbor/asyDetailExport`, params)

// 出港图表模式
export const outChart = (params) => post(`/vip/outHarbor/chart`, params)

// 出港省市排名top10
export const outCityTop = (params) => post(`/vip/outHarbor/cityTop`, params)

// 出港明细
export const outDetail = (params) => post(`/vip/outHarbor/detail`, params)

// 出港列表
export const outList = (params) => post(`/vip/outHarbor/list`, params)

// 出港问题件类型占比
export const problemTypePercentage = (params) => post(`/vip/outHarbor/problemTypePercentage`, params)

// 出港签收率走势图
export const outHarborTrendChart = (params) => post(`/vip/outHarbor/trendChart`, params)
// 修改cod金额
export const modifyCod = params => post('/vip/waybillOrder/modifyCod', params)

// 日志列表
export const logList = params => post('/vip/waybillOrder/logList  ', params)

// 查询审核状态
export const waybillLogByCode = (params) => get(`/vip/waybillOrder/waybillLogByCode`, params)
// 退回件列表
export const rebackExpressList = params => post('/vip/rebackExpress/list', params)

// 单个退回申请校验
export const rebackExpressCheckApply = params => post('/vip/rebackExpress/checkApply', params)

// 退回件申请
export const rebackExpressApply = params => post('/vip/rebackExpress/apply', params)

// 批量退回件申请校验
export const rebackExpressBatchApplyCheck = params => get('/vip/rebackExpress/batchApplyCheck', params)

// 批量退回件申请
export const rebackExpressBatchApply = params => post('/vip/rebackExpress/batchApply', params)

// 退回件导出
export const rebackExpressExport = params => post('/vip/rebackExpress/export', params)

export const rebackExpressDesc = (params) => get(`/vip/rebackExpress/rebackExpressDesc`, params)

/**
 * 创建退货订单
 * @param data
 * @returns {*}
 */
export const fetchCreateReturnOrder = (data) => post('/vip/exchange/return/return/order', data)
/**
 * 创建换货订单
 * @param data
 * @returns {*}
 */
export const fetchCreateExchangeOrder = (data) => post('/vip/exchange/return/exchange/order', data)
/**
 * 查询退货/退换货列表
 * 退换货类型默认为 0 常规单:0 退货单:1 换货单:2
 * @param data
 * @returns {*}
 */
export const fetchReturnExchangeList = (data) => post('/vip/exchange/return/list', data)
/**
 * 查询退换货详情
 * @param data
 * @returns {*}
 */
export const fetchExchangeDetail = (data) => post('/vip/exchange/return/detailOrder', data)
/**
 * 取消退换货
 * @param data
 * @returns {*}
 */
export const fetchCancelExchange = (data) => post('/vip/exchange/return/cancel', data)
/**
 * 检查退换货运单状态
 * @param params
 * @returns {*}
 */
export const fetchExchangeWaybillStatus = (params) => get('/vip/exchange/return/waybill/status', params)
/**
 * 异步导出
 * @param data
 * @returns {*}
 */
export const fetchExchangeExport = (data) => post('/vip/exchange/return/asyExportOrder', data)
/**
 * 获取退换货tab标签页
 * @param data
 * @returns {*}
 */
export const fetchExchangeTab = (data) => post('/vip/exchange/return/totalGroup', data)
/**
 * 图片上传
 * @param data
 * @returns {*}
 */
export const fetchUploadImage = `${process.env.VUE_APP_API_URL}/vip/file/upload`
/**
 * 请求OSS
 * @param data
 * @returns {*}
 */
export const fetchOSS = (data) => post('/vip/file/download/signed/url', data)
/**
 * 更新退换货订单信息
 * @param data
 * @returns {*}
 */
export const fetchUpdateOrderInfo = (data) => post('/vip/exchange/return/updateOrder', data)

/**
 * 判断一单多件限制
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const fetchOneSingleMultiple = (data) => post('/vip/useraddition/isReturnOrSwitch', data)

/**
 * 判断一单多件限制
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const fetchOneSingleMultipleByBatchOrder = (data) => post('/vip/useraddition/checkPackageNumber', data)

// 账号列表
export const getSearchAccounts = (data) => get('/vip/user/getSearchAccounts', data)

// 账号列表
export const getProductTypeAll = (data) => get('/vip/baseData/getProductTypeAll', data)
// 短地址解析
export const getShortAddress = (data) => get('/vip/address/shortAddress', data)
// IMtoken获取
export const livechatToken = (data) => get('/vip/livechat/getToken', data)

// 判断短地址是否有效
export const judgeShortAddress = (data) => post('/vip/preOrder/shortAddressVerify', data)

